// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslateButton-cls1_Esw","cls2":"TranslateButton-cls2_hJ_ TranslateButton-cls1_Esw"};